import { render, staticRenderFns } from "./communityQrcode.vue?vue&type=template&id=230cad04&"
import script from "./communityQrcode.vue?vue&type=script&lang=js&"
export * from "./communityQrcode.vue?vue&type=script&lang=js&"
import style0 from "./communityQrcode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports